import api from "../../../api";

// Ambil semua workflow
export const fetchWorkflows = async () => {
  const response = await api.get('/crm/workflows');
  // console.log('getdata all') 
  // console.log(JSON.stringify(response.data))
  return response.data;
};

// Ambil satu workflow berdasarkan ID
export const getWorkflowById = async (id) => {
  const response = await api.get(`/crm/workflows/${id}`);
  return response.data;
};

// Update workflow berdasarkan ID
export const updateWorkflow = async (id, updatedData) => {
  console.log(JSON.stringify(updatedData))
  const response = await api.put(`/crm/workflows/${id}`, updatedData);
  return response.data;
};

// Tambah workflow baru
export const createWorkflow = async (newData) => {
  // newData.settings[].userId dan userIdIfRevision adalah array
  console.log(JSON.stringify(newData))
  const response = await api.post(`/crm/workflows`, newData);
  return response.data;
};

// Hapus workflow berdasarkan ID
export const deleteWorkflow = async (id) => {
  await api.delete(`/crm/workflows/${id}`);
  return true;
};

// Ambil daftar service (untuk dropdown misalnya)
export const fetchServiceOptions = async () => {
  const response = await api.get('/crm/services/options'); // endpoint harus disesuaikan di controller service
  return response.data.map(service => ({
    id: service.id,
    name: service.name
  }));
};

export const fetchUserOptions = async () => {
  const response = await api.get('/crm/users/user-role-options');
  // console.log('API user response:', response.data); // Tambahkan ini
  // Format hasil: [{ id, name, email, role }]
  return response.data.map(user => ({
    value: user.user_id,
    label: `${user.full_name} (${user.email})`,
    role: user.job_title
  }));
};

export const fetchRoleOptions = async () => {
  const response = await api.get('/crm/users/role-options');
  return response.data.map(role => ({
    id: role.id, // <-- tambahkan ini!
    value: role.name,
    label: role.name.replace('ROLE_', '').replace('_', ' ').toUpperCase()
  }));
};

export const fetchUsersByRoleId = async (roleId) => {
  const response = await api.get(`/crm/users/by-role/${roleId}`);
  return response.data.map(user => ({
    value: user.id,
    label: `${user.label} (${user.email})`,
    email: user.email,
    role: user.role,
    role_id: user.role_id
  }));
};
